export * from './capitalize.directive';
export * from './template.directive';
export * from './trim.directive';
